/**
 * Default route paths. These are used as fallbacks when system_settings are
 * not set or cannot be loaded. To override at runtime, set in Supabase
 * system_settings table:
 *
 *   setting_key: full_cert_registration_path
 *   setting_value: /ecmt-registration-form   (or any path, e.g. /full-cert-registration)
 */
export const ROUTES = {
  /** Full certification / ECMT registration form */
  FULL_CERT_REGISTRATION: "/ecmt-registration-form",
};

/** Helper: full cert registration path with optional id */
export const fullCertRegistrationPath = (id) =>
  id ? `${ROUTES.FULL_CERT_REGISTRATION}/${id}` : ROUTES.FULL_CERT_REGISTRATION;
